import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

export const getBannerRequest = () => ({ type: 'GET_BANNER_REQUEST' })
export const getBannerSuccess = (data) => ({ type: 'GET_BANNER_SUCCESS', data })
export const getBannerFailure = (error) => ({ type: 'GET_BANNER_FAILURE', error })

export const addBannerRequest = () => ({ type: 'ADD_BANNER_REQUEST' })
export const addBannerSuccess = () => ({ type: 'ADD_BANNER_SUCCESS' })
export const addBannerFailure = (error) => ({ type: 'ADD_BANNER_FAILURE', error })

export const updateBannerRequest = () => ({ type: 'UPDATE_BANNER_REQUEST' })
export const updateBannerSuccess = () => ({ type: 'UPDATE_BANNER_SUCCESS' })
export const updateBannerFailure = (error) => ({ type: 'UPDATE_BANNER_FAILURE', error })

export const deleteBannerRequest = () => ({ type: 'DELETE_BANNER_REQUEST' })
export const deleteBannerSuccess = () => ({ type: 'DELETE_BANNER_SUCCESS' })
export const deleteBannerFailure = (error) => ({ type: 'DELETE_BANNER_FAILURE', error })

export const getBanner = () => {
  return (dispatch) => {
    dispatch(getBannerRequest())
    fetch(URL.BASE_URL + URL.END_POINT.banner, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        return response.json()
      })
      .then((data) => {
        dispatch(getBannerSuccess(data))
      })
      .catch((error) => {
        dispatch(getBannerFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const addBanner = (newBanner) => {
  return (dispatch) => {
    dispatch(addBannerRequest())
    fetch(URL.BASE_URL + URL.END_POINT.banner, {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: newBanner,
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(addBannerSuccess())
        toast.success('Banner added successfully')
        dispatch(getBanner())
      })
      .catch((error) => {
        dispatch(addBannerFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const updateBanner = (id, updatedBanner) => {
  return (dispatch) => {
    dispatch(updateBannerRequest())
    fetch(URL.BASE_URL + URL.END_POINT.banner + '?id=' + id, {
      method: 'PUT',
      headers: {
        // 'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
      body: updatedBanner,
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(updateBannerSuccess())
        toast.success('Banner updated successfully')
        dispatch(getBanner())
      })
      .catch((error) => {
        dispatch(updateBannerFailure(error.message))
        toast.error(error.message)
      })
  }
}

export const deleteBanner = (id) => {
  return (dispatch) => {
    dispatch(deleteBannerRequest())
    fetch(URL.BASE_URL + URL.END_POINT.banner + '?id=' + id, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        USERID: localStorage.getItem('USERID'),
        Authorization: `Bearer token=${localStorage.getItem('token')}`,
      },
    })
      .then(async (response) => {
        if (!response.ok) {
          const message = await response.json().then((res) => res.message)
          throw new Error(message)
        }
        dispatch(deleteBannerSuccess())
        toast.success('Banner deleted successfully')
        dispatch(getBanner())
      })
      .catch((error) => {
        dispatch(deleteBannerFailure(error.message))
        toast.error(error.message)
      })
  }
}

const initialState = {
  banners: [],
  loading: false,
  error: null,
}

export const bannerReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_BANNER_REQUEST':
    case 'ADD_BANNER_REQUEST':
    case 'UPDATE_BANNER_REQUEST':
    case 'DELETE_BANNER_REQUEST':
      return { ...state, loading: true, error: null }
    case 'GET_BANNER_SUCCESS':
      return { ...state, banners: action.data.banner, loading: false, error: null }
    case 'ADD_BANNER_SUCCESS':
    case 'UPDATE_BANNER_SUCCESS':
    case 'DELETE_BANNER_SUCCESS':
      return { ...state, loading: false, error: null }
    case 'GET_BANNER_FAILURE':
    case 'ADD_BANNER_FAILURE':
    case 'UPDATE_BANNER_FAILURE':
    case 'DELETE_BANNER_FAILURE':
      return { ...state, loading: false, error: action.error }
    default:
      return state
  }
}
